<template>
  <app-landing-page-layout>
    <staging-password
      v-if="show_staging_protection_page"
      @acceptStaging="staging_password_is_correct = true"
    >
    </staging-password>

    <template v-else>
      <div class="flex h-screen overflow-y-auto">
        <div class="mx-auto mt-12">
          <div class="flex justify-center">
            <img class="w-24" src="/static/logos/parlay_logo.svg" alt="" />
          </div>
          <div class="sign-in-box my-5 box-border shadow-sm p-9 border-1 rounded bg-white">
            <div v-if="authenticator_method === null">
              <div v-if="!reset_pwd_page">
                <span class="mb-4 flex justify-center font-bold text-lg">
                  Sign In to Parlay
                </span>
                <div>
                  <google-button />
                  <microsoft-button />
                </div>
                <div class="flex justify-center my-4 text-gray-400">
                  <div class="line"><span>OR</span></div>
                </div>
                <span class="font-semibold">Email</span>
                <input
                  v-model="user.email"
                  @keyup.enter="login(user)"
                  @keyup="error_message = null"
                  class="bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded border-none"
                  style="border: none !important"
                  type="email"
                />
                <div class="flex justify-between mt-5">
                  <span class="font-semibold">Password</span>
                  <span
                    class="text-pinky cursor-pointer text-xs"
                    @click.prevent="toggleResetPwd(true)"
                  >
                    Forgot password?
                  </span>
                </div>
                <input
                  v-model="user.password"
                  @keyup.enter="login(user)"
                  @keyup="error_message = null"
                  class="bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded border-none"
                  style="border: none !important"
                  type="password"
                />
                <div class="h-5 text-xs text-red-500 italic">
                  {{ error_message }}
                </div>
                <button
                  class="mb-6 px-4 py-2 w-full bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold"
                  @click="login(user)"
                >
                  Continue
                </button>
                <div class="flex justify-center text-xs">
                  <span class="text-gray-400"> Don´t have an account?</span>
                  <router-link :to="{ name: 'signup' }" class="ml-2 text-pinky">
                    Sign Up
                  </router-link>
                </div>
              </div>
              <div v-if="reset_pwd_page">
                <p class="mb-4 flex justify-center font-bold text-lg">
                  Recover Password
                </p>
                <p class="font-semibold">Email</p>
                <input
                  v-model="reset_pwd_email"
                  @keyup="error_message = null"
                  @keyup.enter.prevent="sendEmail"
                  class="bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded"
                  type="email"
                />
                <div class="h-5 text-xs text-red-500 italic">
                  {{ error_message }}
                </div>
                <button
                  class="mb-6 px-4 py-2 w-full bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold"
                  @click="sendEmail"
                >
                  Send Email
                </button>
                <a
                  href="#"
                  @click.prevent="toggleResetPwd(false)"
                  class="flex justify-center text-xs text-pinky"
                >
                  Back to login
                </a>
              </div>
            </div>
            <div v-else>
              <div class="flex justify-center items-center mb-5">
                <div class="w-12 h-12 flex items-center rounded-full justify-center bg-gray-100 shadow">
                  <i class="fa-solid text-base text-blueGray-800 fa-mobile"></i>
                </div>
              </div>
              <div class="flex flex-col space-y-3 mb-7">
                <h4 class="text-base text-center text-gray-800 font-semibold">Two Factor Authentication</h4>
                <span class="text-center">Enter the six digit code displayed on your authenticator app</span>
              </div>
              <div class="flex flex-col space-y-2 mb-4">
                <input v-model="formattedInput" maxlength="7" placeholder="Enter six code generated..." class="px-3 py-2 rounded border border-solid border-gray-200" />
              </div>
              <div class="flex justify-center w-full mb-4">
                <button @click="handleVerifyTwoFactor(user)" class="px-3 py-2 text-white w-full bg-primary hover:bg-primary-dark rounded">Continue to Parlay</button>
              </div>
              <div @click="handleBackLogin()" class="flex hover:underline cursor-pointer justify-center items-center">
                <a>Back to Login</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RecoveryPassword
        v-if="show_confirmation_dialog"
        @close="show_confirmation_dialog = false"
      />
      <div
        v-if="open_ai_alert"
        class="absolute top-0 p-5 w-full flex justify-center items-center text-white"
        style="background: rgba(26, 4, 29, 0.9)"
      >
        Sign in or sign up for your free Parlay teacher account to run this
        class discussion!
      </div>
    </template>
  </app-landing-page-layout>
</template>

<script>
  import googleButton from 'components/svgs/googleButton';
  import microsoftButton from 'components/svgs/microsoftButton';
  import authenticationServices from 'features/authentication/authentication.services';
  import { environment } from 'services/apiConfigs';
  import store from 'store';
  import axios from 'axios';
  import 'features/authentication/authentication.styles.styl';
  import { EventBus } from "utils/event-bus";
  import configs from 'services/apiConfigs';

  export default {
    data() {
      return {
        user: {
          email: null,
          password: null,
        },
        error: null,
        error_message: '',
        reset_pwd_page: false,
        reset_pwd_email: '',
        staging_password_is_correct: false,
        show_confirmation_dialog: false,
        open_ai_alert: false,
        authenticator_method: null,
        token2fa: '',
        tokenAuth: null,
        userId: null,
      };
    },
    components: {
      appLandingPageLayout: require('layouts/appLandingPage/appLandingPage.vue'),
      stagingPassword: require('features/authentication/components/stagingPassword.vue'),
      landingPageTitle: require('features/authentication/components/landingPageTitle.vue'),
      googleButton,
      RecoveryPassword: () => import('./ModalRecoveryPassword.vue'),
      microsoftButton,
    },
    computed: {
      show_staging_protection_page() {
        return !this.staging_password_is_correct && this.environment_is_staging;
      },
      environment_is_staging() {
        return environment === 'staging' || environment === 'staging_two';
      },
      environment_is_production() {
        return environment === 'production';
      },
      formattedInput: {
        get() {
          let digits = this.token2fa.replace(/\D/g, '');
          let formatted = digits.replace(/(\d{3})(\d{3})/, '$1 $2');
          return formatted;
        },
        set(value) {
          this.token2fa = value.replace(/\D/g, '');
        }
      }
    },
    methods: {
      // setTimeout is used because this allows v-model time to model correctly
      login(user) {
        setTimeout(() => {
          user.email = user.email.toLowerCase();
          authenticationServices.login(user).then((res) => {
            if (res.data.two_factor_auth === null) {
              const auth_token = res.data.token;
              authenticationServices.redirectToAuthClient(auth_token);
              store.dispatch('login', auth_token);
              this.$store.commit('setIsReloadComponent');
            } else {
              this.authenticator_method = res.data.two_factor_auth;
              this.tokenAuth = res.data.token;
              this.userId = res.data.id;
            }
            
          })
          .catch((err) => {
            this.error_message = err.response.status === 401 ? 'Email and password combination is incorrect' : err.response.data.message;
            return null;
          });
        }, 400);
      },
      handleVerifyTwoFactor: async function() {
        /* Improve this flow */
        try {
          const response = await axios.post(`/api/users/two-factor-authentication/verify`, {
            token: this.formattedInput.replace(/\s/g, ""),
            user_id: this.userId
          });
          if(response.data.is_valid === true) {
            authenticationServices.redirectToAuthClient(this.tokenAuth);
            store.dispatch('login', this.tokenAuth);
            this.$store.commit('setIsReloadComponent');
          }
        } catch (error) {
          const toast = {
            type: 'Error',
            message: 'The six code digit is not valid! Please try again!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        }
      },
      handleBackLogin: function() {
        this.authenticator_method = null;
        this.tokenAuth = null;
        this.userId = null;
      },
      goToCleverSSO() {
        const url_base =
          'https://clever.com/oauth/authorize?response_type=code';
        const redirect_uri =
          environment === 'development'
            ? 'http://ad312a30.ngrok.io/auth/clever'
            : `${configs.apiURL}/auth/clever`;
        const client_id =
          environment === 'production'
            ? process.env.CLEVER_CLIENT_ID
            : process.env.CLEVER_CLIENT_STAGING_ID;
        const fullURI = `${url_base}&redirect_uri=${redirect_uri}&client_id=${client_id}`;
        console.log(fullURI);
        window.location.href = fullURI;
      },
      toggleResetPwd(status) {
        this.reset_pwd_page = status;
        this.error_message = '';
      },
      closeDialog(ref) {
        this.reset_pwd_page = false;
        this.$refs[ref].close();
      },
      // TODO: Do not throw error on the backend no matter what. Always the same response
      sendEmail() {
        if (!this.reset_pwd_email || this.reset_pwd_email.trim() === '') {
          this.error_message = 'Email field cannot be blank';
          return;
        }
        if (!this.isAnEmail(this.reset_pwd_email.trim())) {
          this.error_message = 'Invalid Email';
          return;
        }
        this.reset_pwd_email = this.reset_pwd_email.toLowerCase();
        authenticationServices
          .forgotPassword({ email: this.reset_pwd_email })
          .then(() => {
            this.show_confirmation_dialog = true;
            return null;
          })
          .catch((err) => {
            this.error_message = 'Error. Please try again.';
            console.error(err);
            return null;
          });
      },
      isAnEmail(email) {
        var regex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
      },
    },
    mounted() {
      window.gtag('config', 'UA-90906114-1', { page_path: '/account/signup' });
      if (this.$route.query.action === 'logout')
        this.$router.push(this.$route.fullPath.replace('logout', 'login'));
      const open_ai = localStorage.getItem('open_ai');
      if (open_ai) {
        this.open_ai_alert = true;
        setTimeout(() => {
          this.open_ai_alert = false;
        }, 5000);
      }
    },
  };
</script>

<style scoped lang="stylus">
  .line
    width: 100%
    text-align: center
    border-bottom: 1px solid rgba(156,163,175,1)
    line-height: 0em
    margin: 10px 0 10px
    span
      background:#fff
      padding:0 10px
      font-size: 12px

  .sign-in-box
    width: 500px
    @media (max-width: 639px)
      width: 100vw
</style>



// WEBPACK FOOTER //
// login.vue?e92e0868